<template>

    <el-card>
        <div class="announcement-header">
            <div class="announcement-icon">
                <i class="el-icon-location-outline"></i>
            </div>
            <div class="announcement-title">食材模版</div>
        </div>
        <div class="device-table-container">
            <div class="checkin-overview-list">
                <div class="overview-header">
                    <div class="header-item">模版ID</div>
                    <div class="header-item">模版名称</div>
                    <div class="header-item">模版类别</div>
                    <div class="header-item">模版图片</div>

                    <div class="header-item">预警天数</div>
                    <div class="header-item">预警数量</div>

                </div>
                <!-- 滚动列表的视窗容器 -->
                <div class="marquee-container">
                    <div class="overview-body">
                        <div class="overview-row" v-for="(item, index) in templateList" :key="index">
                            <div class="body-item">{{ item.pid }}</div>
                            <div class="body-item">{{ item.pname }}</div>
                            <div class="body-item">{{ item.ptype }}</div>
                            <div class="body-item"> <img :src="item.proImgPath" alt=""></div>
                            <div class="body-item"> {{ item.alDay }}</div>

                            <div class="body-item"> {{ item.alNum }}{{ item.punit }}</div>


                        </div>
                        <div class="empty-tip" v-if="templateList.length === 0">
                            暂无数据
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-card>
</template>

<script>
import * as echarts from 'echarts'
import { getAllProducts } from "@/api/ingredients";

export default {
    data() {
        return {
            // 搜索表单
            searchForm: {
                pName: '',
                pType: ''
            },
            // 模版列表
            templateList: [],
            // 分页参数
            currentPage: 1,
            pageSize: 10,
            totalCount: 0,
            // 弹窗状态
            formDialogVisible: false,
            dialogTitle: '新增模版',
            nutritionDialogVisible: false,
            nutrientDialogVisible: false,
            // 当前操作类型（add/edit）
            currentOperation: 'add',
            // 标签页激活状态
            activeTab: 'nutritionComponent',

            // 上传配置
            uploadHeaders: {
                Authorization: 'Bearer ' + localStorage.getItem('token')
            },
            errorImage: 'https://via.placeholder.com/150x100?text=无图片',

            // 模版表单数据（含文件对象）
            templateForm: {
                pid: '',          // 模版ID
                pname: '',        // 模版名称
                ptype: '',        // 模版类别
                proImgPath: '',   // 图片URL（用于预览）
                file: null, // 图片文件对象（用于上传）
                alDay: '',        // 预警天数
                alNum: '',        // 预警数量
                punit: ''         // 单位
            },

            // 营养分析数据
            nutritionData: {
                totalCalorie: 220.0,
                protein: 15.0,
                fat: 14.0,
                carbohydrate: 10.0,
                details: [
                    { nutrient: '热量', content: '220.0 kcal', dailyPercentage: '11%' },
                    { nutrient: '蛋白质', content: '15.0 g', dailyPercentage: '25%' },
                    { nutrient: '脂肪', content: '14.0 g', dailyPercentage: '22%' },
                    { nutrient: '碳水化合物', content: '10.0 g', dailyPercentage: '3%' },
                    { nutrient: '钙', content: '180.0 mg', dailyPercentage: '18%' }
                ]
            },

            // 营养素编辑表单
            nutrientForm: {
                nutrient: '',
                content: '',
                dailyPercentage: ''
            },

            // 当前编辑的营养素索引
            currentNutrientIndex: -1,

            // 表单校验规则
            templateRules: {
                pname: [
                    { required: true, message: '请输入模版名称', trigger: 'blur' }
                ],
                ptype: [
                    { required: true, message: '请选择模版类别', trigger: 'change' }
                ],
                alDay: [
                    { required: true, message: '请输入预警天数', trigger: 'blur' },
                    { type: 'number', min: 1, message: '预警天数不能小于1', trigger: 'blur' }
                ],
                alNum: [
                    { required: true, message: '请输入预警数量', trigger: 'blur' },
                    { type: 'number', min: 1, message: '预警数量不能小于1', trigger: 'blur' }
                ],
                punit: [
                    { required: true, message: '请选择单位', trigger: 'change' }
                ]
            },

            // 营养素表单校验规则
            nutrientRules: {
                nutrient: [
                    { required: true, message: '请输入营养素名称', trigger: 'blur' }
                ],
                content: [
                    { required: true, message: '请输入含量', trigger: 'blur' }
                ],
                dailyPercentage: [
                    { required: true, message: '请输入每日参考值%', trigger: 'blur' }
                ]
            }
        }
    },

    mounted() {
        this.getTemplateList();
        this.$echarts = echarts;
    },

    methods: {
        // 新增：前端兜底筛选方法
        filterTemplateData(rawData) {
            if (!Array.isArray(rawData)) return [];

            return rawData.filter(item => {
                // 1. 模版名称筛选（模糊匹配，不区分大小写）
                if (this.searchForm.pName) {
                    const keyword = this.searchForm.pName.toLowerCase().trim();
                    const pname = (item.pname || '').toLowerCase();
                    if (!pname.includes(keyword)) {
                        return false;
                    }
                }

                // 2. 模版类别筛选（精确匹配）
                if (this.searchForm.pType) {
                    if (item.ptype !== this.searchForm.pType) {
                        return false;
                    }
                }

                return true;
            });
        },

        // 获取模版列表（修复筛选逻辑）
        getTemplateList() {
            // 构建筛选参数
            const params = {
                userId: localStorage.getItem('userId'),
                // 传递筛选参数给后端
                pName: this.searchForm.pName.trim() || '',
                pType: this.searchForm.pType || ''
            };

            getAllProducts(params).then(response => {
                // 先通过后端筛选，再做前端兜底筛选
                const rawData = response.data || [];
                this.templateList = this.filterTemplateData(rawData);
                this.totalCount = this.templateList.length;
                // 重置页码为第一页
                this.currentPage = 1;
            }).catch(error => {
                console.error('获取模版列表失败:', error);
                this.$message.error('获取数据失败，请重试');
                this.templateList = [];
                this.totalCount = 0;
            });
        },







        // 图片选择变化：保存文件对象和预览URL
        handleImageChange(file) {
            // 保存文件对象（用于上传）
            this.templateForm.file = file.raw;
            // 生成预览URL（用于页面显示）
            this.templateForm.proImgPath = URL.createObjectURL(file.raw);
            console.log('图片文件对象:', this.templateForm.file);
            console.log('预览URL:', this.templateForm.proImgPath);
        },

        // 移除图片
        handleImageRemove() {
            // 释放预览URL内存
            if (this.templateForm.proImgPath) {
                URL.revokeObjectURL(this.templateForm.proImgPath);
            }
            this.templateForm.file = null;
            this.templateForm.proImgPath = '';
        },

        /**
         * 图片上传前校验
         * 修改：将2MB限制改为200KB
         */
        beforeImageUpload(file) {
            const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
            // 关键修改：200KB = 200 * 1024 字节
            const isLt200K = file.size / 1024 < 200;

            if (!isJPG) this.$message.error('只能上传 JPG/PNG 格式的图片');
            if (!isLt200K) this.$message.error('图片大小不能超过 200KB');

            return isJPG && isLt200K;
        },




        // 营养素编辑相关
        editNutrient(row) {
            this.currentNutrientIndex = this.nutritionData.details.findIndex(item => item.nutrient === row.nutrient);
            this.nutrientForm = { ...row };
            this.nutrientDialogVisible = true;
        },
        deleteNutrient(index) {
            this.nutritionData.details.splice(index, 1);
            this.$message.success('营养素已删除');
        },
        addNutrient() {
            this.currentNutrientIndex = -1;
            this.nutrientForm = { nutrient: '', content: '', dailyPercentage: '' };
            this.nutrientDialogVisible = true;
        },
        saveNutrient() {
            this.$refs.nutrientFormRef.validate((isValid) => {
                if (isValid) {
                    if (this.currentNutrientIndex === -1) {
                        this.nutritionData.details.push({ ...this.nutrientForm });
                    } else {
                        this.nutritionData.details[this.currentNutrientIndex] = { ...this.nutrientForm };
                    }
                    this.nutrientDialogVisible = false;
                    this.$message.success('营养素保存成功');
                    if (this.activeTab === 'nutritionChart') {
                        this.initCharts();
                    }
                }
            });
        }
    },

    beforeDestroy() {
        // 清除图片预览URL，释放内存
        if (this.templateForm.proImgPath) {
            URL.revokeObjectURL(this.templateForm.proImgPath);
        }
        // 移除图表监听
        window.removeEventListener('resize', () => {
            const pieChart = this.$echarts.getInstanceByDom(document.getElementById('nutritionPieChart'));
            if (pieChart) pieChart.resize();
        });
    },

    // 新增：关闭弹窗时释放图片预览URL
    watch: {
        formDialogVisible(newVal) {
            if (!newVal && this.templateForm.proImgPath) {
                URL.revokeObjectURL(this.templateForm.proImgPath);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.announcement-header {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    padding: 10px 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
    margin-bottom: 15px;

    .announcement-icon {
        color: #faad14;
        font-size: 20px;
        margin-right: 10px;
    }
}

.device-table-container {
    display: flex;
    flex-direction: column;
    height: calc(100% - 60px);
    overflow: hidden;
}

// --- 自动滚动列表样式 ---
.checkin-overview-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .overview-header {
        display: flex;
        background-color: #f8f9fa;
        font-weight: 600;
        padding: 12px 0;
        border-bottom: 1px solid #e8e8e8;
        z-index: 10;

        .header-item {
            flex: 1;
            text-align: center;
            color: #333;
        }
    }

    .marquee-container {
        flex: 1;
        overflow: hidden;
    }

    .overview-body {
        animation: scroll-up-device-table 60s linear infinite;
        height: 100%;

        &:hover {
            animation-play-state: paused;
        }

        .overview-row {
            display: flex;
            align-items: center;
            padding: 10px 0;
            border-bottom: 1px dashed #f0f0f0;

            &:hover {
                background-color: #f8f9fa;
            }

            .body-item {
                flex: 1;
                text-align: center;
                color: #666;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        .empty-tip {
            text-align: center;
            padding: 50px 0;
            color: #999;
        }
    }
}

// 设备列表滚动动画
@keyframes scroll-up-device-table {
    0% {
        transform: translateY(0);
    }

    100% {
        transform: translateY(calc(-100% + 30vh));
    }
}
</style>